export default {

    state: () => ({
        histories: [],
    }),

    getters: {
        getterHistories(state) {
            return state.histories
        }
    },

    mutations: {
        setterHistories(state, data) {
            state.histories = data
        }
    },

    actions: {
        getHistories({commit}, {targetId, type}) {
            let formData = {
                limit: 20,
                same_targets: 1
            };

            if (type === 'project') {
                formData['project_id'] = targetId
            } else {
                formData['pet_id'] = targetId
            }

            axios.get(`/api/histories/last-histories`, {params: formData})
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        commit('setterHistories', response.data)
                    }
                });
        },
    }

}
